import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
        訂閱電子報
        </p>
        <p className='footer-subscription-text'>
        現在訂閱電子報就享折扣，接受第一手最新商品消息！
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='你的信箱：Ｄ'
            />
            <Button buttonStyle='btn--outline'>訂閱</Button>
          </form>
        </div>
      </section>
      <div className='footer-links'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>SamKo.</h2>
            <Link to='/'>全端網站工程師/顧問</Link>
            <Link to='/'>後端api</Link>
            <Link to='/'>頁面優化</Link>
            <Link to='/'>SEO搜尋字</Link>
            <Link to='/'>後台管理</Link>
          </div>
          <div className='footer-link-items'>
            <h2>客製化功能</h2>
            <Link to='/'>聯絡介面</Link>
            <Link to='/'>購物車</Link>
            <Link to='/'>產品介面</Link>
            <Link to='/'>蝦皮類型的可愛按鈕</Link>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>產品合作類型</h2>
            <Link to='/'>男士商品</Link>
            <Link to='/'>女士服飾</Link>
            <Link to='/'>服飾配件</Link>
            <Link to='/'>我的帳戶</Link>
          </div>
          <div className='footer-link-items'>
            <h2>聯絡我們</h2>
            <Link to='/'>Instagram</Link>
            <Link to='/'>Facebook</Link>
            <Link to='/'>Youtube</Link>
            <Link to='/'>Twitter</Link>
          </div>
        </div>
      </div>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              SamKo
              
            </Link>
          </div>
          <small className='website-rights'>SamKo © 2021</small>
          <div className='social-icons'>
            <Link
              className='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </Link>
            <Link
              className='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </Link>
            <Link
              className='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </Link>
            <Link
              className='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='Twitter'
            >
              <i className='fab fa-twitter' />
            </Link>
            <Link
              className='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i className='fab fa-linkedin' />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
